import { __assign, __awaiter, __generator } from "tslib";
import { HttpRequest } from "@aws-sdk/protocol-http";
import { parse as parseArn, validate as validateArn } from "@aws-sdk/util-arn-parser";
import { bucketHostname } from "./bucketHostname";
import { getPseudoRegion } from "./bucketHostnameUtils";
export var bucketEndpointMiddleware = function bucketEndpointMiddleware(options) {
  return function (next, context) {
    return function (args) {
      return __awaiter(void 0, void 0, void 0, function () {
        var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, clientRegion, _e, _f, hostname, bucketEndpoint;

        return __generator(this, function (_g) {
          switch (_g.label) {
            case 0:
              bucketName = args.input.Bucket;
              replaceBucketInPath = options.bucketEndpoint;
              request = args.request;
              if (!HttpRequest.isInstance(request)) return [3
              /*break*/
              , 8];
              if (!options.bucketEndpoint) return [3
              /*break*/
              , 1];
              request.hostname = bucketName;
              return [3
              /*break*/
              , 7];

            case 1:
              if (!validateArn(bucketName)) return [3
              /*break*/
              , 5];
              bucketArn = parseArn(bucketName);
              _a = getPseudoRegion;
              return [4
              /*yield*/
              , options.region()];

            case 2:
              clientRegion = _a.apply(void 0, [_g.sent()]);
              return [4
              /*yield*/
              , options.regionInfoProvider(clientRegion)];

            case 3:
              _b = _g.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
              return [4
              /*yield*/
              , options.useArnRegion()];

            case 4:
              useArnRegion = _g.sent();
              _d = bucketHostname({
                bucketName: bucketArn,
                baseHostname: request.hostname,
                accelerateEndpoint: options.useAccelerateEndpoint,
                dualstackEndpoint: options.useDualstackEndpoint,
                pathStyleEndpoint: options.forcePathStyle,
                tlsCompatible: request.protocol === "https:",
                useArnRegion: useArnRegion,
                clientPartition: partition,
                clientSigningRegion: signingRegion,
                clientRegion: clientRegion,
                isCustomEndpoint: options.isCustomEndpoint
              }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService; // If the request needs to use a region or service name inferred from ARN that different from client region, we
              // need to set them in the handler context so the signer will use them

              if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) {
                context["signing_region"] = modifiedSigningRegion;
              }

              if (signingService && signingService !== "s3") {
                context["signing_service"] = signingService;
              }

              request.hostname = hostname;
              replaceBucketInPath = bucketEndpoint;
              return [3
              /*break*/
              , 7];

            case 5:
              _e = getPseudoRegion;
              return [4
              /*yield*/
              , options.region()];

            case 6:
              clientRegion = _e.apply(void 0, [_g.sent()]);
              _f = bucketHostname({
                bucketName: bucketName,
                clientRegion: clientRegion,
                baseHostname: request.hostname,
                accelerateEndpoint: options.useAccelerateEndpoint,
                dualstackEndpoint: options.useDualstackEndpoint,
                pathStyleEndpoint: options.forcePathStyle,
                tlsCompatible: request.protocol === "https:",
                isCustomEndpoint: options.isCustomEndpoint
              }), hostname = _f.hostname, bucketEndpoint = _f.bucketEndpoint;
              request.hostname = hostname;
              replaceBucketInPath = bucketEndpoint;
              _g.label = 7;

            case 7:
              if (replaceBucketInPath) {
                request.path = request.path.replace(/^(\/)?[^\/]+/, "");

                if (request.path === "") {
                  request.path = "/";
                }
              }

              _g.label = 8;

            case 8:
              return [2
              /*return*/
              , next(__assign(__assign({}, args), {
                request: request
              }))];
          }
        });
      });
    };
  };
};
export var bucketEndpointMiddlewareOptions = {
  tags: ["BUCKET_ENDPOINT"],
  name: "bucketEndpointMiddleware",
  relation: "before",
  toMiddleware: "hostHeaderMiddleware",
  override: true
};
export var getBucketEndpointPlugin = function getBucketEndpointPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(bucketEndpointMiddleware(options), bucketEndpointMiddlewareOptions);
    }
  };
};